module.exports = __webpack_public_path__ + "static/media/5.ed9a0d42.png";